
export default class GeolocUtils {

  static PARIS_LOCATION = {
    lat: 48.864716,
    lng: 2.349014,
  }

}
